<template>
  <v-container fluid>
    <fin-demo-tool/>
  </v-container>
</template>

<script>
import FinDemoTool from "@/components/common/demoTool/DemoTool"

export default {
  name: "DemoTool",
  components: {FinDemoTool}
}
</script>

<style scoped>

</style>
